<div class="min-h-screen overflow-x-hidden bg-white">
  <nav
    class="flex flex-wrap items-center w-full text-sm md:text-base whitespace-nowrap px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-3 sm:pb-1"
    aria-label="Breadcrumb">
    <span class="gap-2.5 self-stretch my-auto font-medium text-blue-600 cursor-pointer hover:text-blue-800"
      (click)="gotoHome()">Home</span>
    <img
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/ad717c8dff265b06c980cdf8b02be84cef419a14?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
      class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" alt="Breadcrumb separator" />
    <span class="gap-2.5 self-stretch my-auto font-bold text-blue-950">{{
      getBreadcrumbLabel()
      }}</span>
  </nav>

  <main class="mt-1 sm:mt-3 w-full max-w-full px-4 sm:px-6 lg:px-8 pb-8" [attr.space]="24">
    <div class="flex items-start gap-5 max-md:flex-col max-md:gap-4">
      <div
        class="left-sidebar w-full md:w-[30%] lg:w-[25%] mb-2 hidden md:block shrink-0 md:sticky md:top-4 md:self-start md:max-h-[calc(100vh-120px)] md:overflow-y-auto">
        <aside
          class="grow w-full bg-white rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] max-md:mt-6">
          <header class="w-full">
            <div class="pb-6 w-full">
              <div
                class="flex flex-col items-center px-16 pt-9 bg-blue-500 rounded-lg max-md:px-5 md:px-8 md:pt-7 lg:px-16 lg:pt-9">
                <div
                  class="w-[60px] h-[60px] rounded-lg bg-blue-200 text-blue-600 flex items-center justify-center font-bold text-4xl z-10 mb-[-30px] max-md:mb-2.5 md:w-[50px] md:h-[50px] md:text-3xl md:mb-[-25px] lg:w-[60px] lg:h-[60px] lg:text-4xl lg:mb-[-30px]">
                  {{ (user?.first_name || "guest").charAt(0).toUpperCase() }}
                </div>
              </div>
            </div>
            <h2
              class="mt-2 w-full text-xl font-bold leading-snug text-black text-center flex justify-center items-center md:text-lg lg:text-xl">
              {{ fullName }}
            </h2>
          </header>

          <nav class="mt-6 w-full text-base font-bold text-zinc-700 md:mt-4 md:text-sm lg:mt-6 lg:text-base"
            aria-label="Profile navigation">
            <ul class="list-none p-0 m-0">
              <li (click)="setSection('profile')" [ngClass]="
                  selectedSection === 'profile'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14 12H10C7.23858 12 5 14.2386 5 17V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V17C19 14.2386 16.7614 12 14 12Z"
                    [attr.fill]="
                      selectedSection === 'profile' ? '#307FE1' : 'black'
                    " fill="black" />
                  <path
                    d="M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z"
                    [attr.fill]="
                      selectedSection === 'profile' ? '#307FE1' : 'black'
                    " fill="black" />
                </svg>

                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'profile'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Profile</span>
              </li>
              <li (click)="setSection('orders')" [ngClass]="
                  selectedSection === 'orders'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square">
                  <path
                    d="M0.75 4.75L9.75 0.75L14.25 2.75M0.75 4.75V14.75L9.75 18.75M0.75 4.75L5.25 6.75M18.75 4.75L9.75 8.75M18.75 4.75V14.75L9.75 18.75M18.75 4.75L14.25 2.75M9.75 8.75V18.75M9.75 8.75L5.25 6.75M5.25 6.75L14.25 2.75"
                    [attr.stroke]="
                      selectedSection === 'orders' ? '#307FE1' : 'black'
                    " stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'orders'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Orders & Returns</span>
              </li>
              <!-- <li (click)="setSection('my-garage')"
                                [ngClass]="selectedSection === 'my-garage' ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer' : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'">
                                                                                               <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path [attr.stroke]="selectedSection === 'my-garage' ? '#307FE1' : 'black'" d="M13.75 12.75H7.75M13.75 12.75C13.75 13.8546 14.6454 14.75 15.75 14.75C16.8546 14.75 17.75 13.8546 17.75 12.75M13.75 12.75C13.75 11.6454 14.6454 10.75 15.75 10.75C16.8546 10.75 17.75 11.6454 17.75 12.75M7.75 12.75C7.75 13.8546 6.85457 14.75 5.75 14.75C4.64543 14.75 3.75 13.8546 3.75 12.75M7.75 12.75C7.75 11.6454 6.85457 10.75 5.75 10.75C4.64543 10.75 3.75 11.6454 3.75 12.75M3.75 12.75H0.75V8.75C0.75 7.64543 1.64543 6.75 2.75 6.75H3.75M17.75 12.75H20.75V10.75C20.75 8.54086 18.9591 6.75 16.75 6.75H15.75M15.75 6.75L14.4338 2.80132C14.0254 1.57629 12.879 0.75 11.5877 0.75H7.75M15.75 6.75H7.75M3.75 6.75L4.3322 3.2568C4.57329 1.81024 5.82486 0.75 7.29138 0.75H7.75M3.75 6.75H7.75M7.75 0.75V6.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                                <span class="self-stretch my-auto"
                                    [ngClass]="selectedSection === 'my-garage' ? 'text-blue-500' : 'text-zinc-700'"> {{ selectedSection === 'my-garage' ? 'My Garage' : 'Garage' }}</span>
                            </li> -->
              <li (click)="setSection('address')" [ngClass]="
                  selectedSection === 'address'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">

                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square">
                  <path
                    d="M5 8.91995C5 12.6683 6.34786 14.6401 11.173 21.5716C11.5706 22.1428 12.4294 22.1428 12.827 21.5716C17.6521 14.6401 19 12.6683 19 8.91995C19 5.09817 15.866 2 12 2C8.13401 2 5 5.09817 5 8.91995Z"
                    [attr.stroke]="selectedSection === 'address' ? '#307FE1' : 'black'" stroke-width="1.5"
                    stroke-linejoin="round" />

                  <circle cx="12" cy="9" r="2" [attr.stroke]="selectedSection === 'address' ? '#307FE1' : 'black'"
                    stroke-width="1.5" />
                </svg>
                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'address'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Saved Addresses</span>
              </li>
              <li (click)="setSection('wishlist')" [ngClass]="
                  selectedSection === 'wishlist'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.1555 5.50284C9.2898 3.49947 6.26494 3.49947 4.39926 5.50284C2.53358 7.50622 2.53358 10.7543 4.39926 12.7577L10.5528 19.3654C11.3408 20.2115 12.6592 20.2115 13.4472 19.3654L19.6007 12.7577C21.4664 10.7543 21.4664 7.50559 19.6007 5.50222C17.7351 3.49884 14.7102 3.49947 12.8445 5.50284C12.3781 6.00369 11.6219 6.00369 11.1555 5.50284Z"
                    [attr.stroke]="
                      selectedSection === 'wishlist' ? '#307FE1' : 'black'
                    " stroke-width="1.5" stroke-linejoin="round" />
                </svg>

                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'wishlist'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Wishlist</span>
              </li>
              <li (click)="setSection('coupons')" [ngClass]="
                  selectedSection === 'coupons'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.1313 1.59717C15.5752 0.752793 17.4264 1.51996 17.85 3.13818L18.3237 4.94482C18.4177 5.30325 18.6976 5.58339 19.0561 5.67725L20.8627 6.15088C22.4807 6.57482 23.2482 8.42585 22.4037 9.86963L21.4604 11.4819C21.2732 11.8019 21.2732 12.1991 21.4604 12.519L22.4037 14.1313C23.2477 15.5751 22.4806 17.4263 20.8627 17.8501L19.0561 18.3237C18.6974 18.4176 18.4176 18.6975 18.3237 19.0562L17.85 20.8628C17.4263 22.4807 15.5751 23.2478 14.1313 22.4038L12.519 21.4604C12.199 21.2733 11.8019 21.2733 11.4819 21.4604L9.86957 22.4038C8.42578 23.2482 6.57475 22.4807 6.15082 20.8628L5.67719 19.0562C5.58333 18.6977 5.30318 18.4178 4.94476 18.3237L3.13812 17.8501C1.5199 17.4264 0.752735 15.5753 1.59711 14.1313L2.54047 12.519C2.72758 12.1992 2.72738 11.8019 2.54047 11.4819L1.59711 9.86963C0.752606 8.42569 1.51985 6.57456 3.13812 6.15088L4.94476 5.67725C5.30319 5.58329 5.58323 5.30325 5.67719 4.94482L6.15082 3.13818C6.5745 1.51991 8.42564 0.75267 9.86957 1.59717L11.4819 2.54053C11.8018 2.72744 12.1991 2.72764 12.519 2.54053L14.1313 1.59717ZM9.11273 2.89209C8.52623 2.54897 7.77409 2.86073 7.60199 3.51807L7.12836 5.32471C6.89712 6.20751 6.20745 6.89718 5.32465 7.12842L3.51801 7.60205C2.86067 7.77415 2.54891 8.52629 2.89203 9.11279L3.83539 10.7251C4.2959 11.5128 4.2961 12.4882 3.83539 13.2759L2.89203 14.8882C2.54904 15.4747 2.86072 16.2268 3.51801 16.3989L5.32465 16.8726C6.20744 17.1039 6.89721 17.7934 7.12836 18.6763L7.60199 20.4829C7.77434 21.1399 8.52639 21.4519 9.11273 21.1089L10.725 20.1655C11.5128 19.7048 12.4881 19.7047 13.2758 20.1655L14.8881 21.1089C15.4745 21.4515 16.2267 21.1399 16.3989 20.4829L16.8725 18.6763C17.1037 17.7932 17.7932 17.1037 18.6762 16.8726L20.4828 16.3989C21.1398 16.2267 21.4514 15.4745 21.1088 14.8882L20.1655 13.2759C19.7047 12.4881 19.7047 11.5129 20.1655 10.7251L21.1088 9.11279C21.4519 8.52645 21.1398 7.7744 20.4828 7.60205L18.6762 7.12842C17.7933 6.89727 17.1038 6.20751 16.8725 5.32471L16.3989 3.51807C16.2268 2.86078 15.4746 2.5491 14.8881 2.89209L13.2758 3.83545C12.4882 4.29616 11.5128 4.29596 10.725 3.83545L9.11273 2.89209ZM14.7504 13.5005C15.4406 13.5007 16.0004 14.0603 16.0004 14.7505C16.0002 15.4405 15.4404 16.0003 14.7504 16.0005C14.0602 16.0005 13.5007 15.4406 13.5004 14.7505C13.5004 14.0601 14.0601 13.5005 14.7504 13.5005ZM14.4702 8.47021C14.763 8.17732 15.2378 8.17732 15.5307 8.47021C15.8232 8.76314 15.8234 9.23801 15.5307 9.53076L9.5307 15.5308C9.23795 15.8235 8.76308 15.8232 8.47015 15.5308C8.17726 15.2379 8.17726 14.7631 8.47015 14.4702L14.4702 8.47021ZM9.25043 8.00049C9.94058 8.00072 10.5004 8.56028 10.5004 9.25049C10.5002 9.9405 9.94044 10.5003 9.25043 10.5005C8.56022 10.5005 8.00066 9.94065 8.00043 9.25049C8.00043 8.56013 8.56007 8.00049 9.25043 8.00049Z"
                    [attr.fill]="
                      selectedSection === 'coupons' ? '#307FE1' : 'black'
                    " fill="black" />
                  <path
                    d="M14.1313 1.59717C15.5752 0.752793 17.4264 1.51996 17.85 3.13818L18.3237 4.94482C18.4177 5.30325 18.6976 5.58339 19.0561 5.67725L20.8627 6.15088C22.4807 6.57482 23.2482 8.42585 22.4037 9.86963L21.4604 11.4819C21.2732 11.8019 21.2732 12.1991 21.4604 12.519L22.4037 14.1313C23.2477 15.5751 22.4806 17.4263 20.8627 17.8501L19.0561 18.3237C18.6974 18.4176 18.4176 18.6975 18.3237 19.0562L17.85 20.8628C17.4263 22.4807 15.5751 23.2478 14.1313 22.4038L12.519 21.4604C12.199 21.2733 11.8019 21.2733 11.4819 21.4604L9.86957 22.4038C8.42578 23.2482 6.57475 22.4807 6.15082 20.8628L5.67719 19.0562C5.58333 18.6977 5.30318 18.4178 4.94476 18.3237L3.13812 17.8501C1.5199 17.4264 0.752735 15.5753 1.59711 14.1313L2.54047 12.519C2.72758 12.1992 2.72738 11.8019 2.54047 11.4819L1.59711 9.86963C0.752606 8.42569 1.51985 6.57456 3.13812 6.15088L4.94476 5.67725C5.30319 5.58329 5.58323 5.30325 5.67719 4.94482L6.15082 3.13818C6.5745 1.51991 8.42564 0.75267 9.86957 1.59717L11.4819 2.54053C11.8018 2.72744 12.1991 2.72764 12.519 2.54053L14.1313 1.59717ZM9.11273 2.89209C8.52623 2.54897 7.77409 2.86073 7.60199 3.51807L7.12836 5.32471C6.89712 6.20751 6.20745 6.89718 5.32465 7.12842L3.51801 7.60205C2.86067 7.77415 2.54891 8.52629 2.89203 9.11279L3.83539 10.7251C4.2959 11.5128 4.2961 12.4882 3.83539 13.2759L2.89203 14.8882C2.54904 15.4747 2.86072 16.2268 3.51801 16.3989L5.32465 16.8726C6.20744 17.1039 6.89721 17.7934 7.12836 18.6763L7.60199 20.4829C7.77434 21.1399 8.52639 21.4519 9.11273 21.1089L10.725 20.1655C11.5128 19.7048 12.4881 19.7047 13.2758 20.1655L14.8881 21.1089C15.4745 21.4515 16.2267 21.1399 16.3989 20.4829L16.8725 18.6763C17.1037 17.7932 17.7932 17.1037 18.6762 16.8726L20.4828 16.3989C21.1398 16.2267 21.4514 15.4745 21.1088 14.8882L20.1655 13.2759C19.7047 12.4881 19.7047 11.5129 20.1655 10.7251L21.1088 9.11279C21.4519 8.52645 21.1398 7.7744 20.4828 7.60205L18.6762 7.12842C17.7933 6.89727 17.1038 6.20751 16.8725 5.32471L16.3989 3.51807C16.2268 2.86078 15.4746 2.5491 14.8881 2.89209L13.2758 3.83545C12.4882 4.29616 11.5128 4.29596 10.725 3.83545L9.11273 2.89209ZM14.7504 13.5005C15.4406 13.5007 16.0004 14.0603 16.0004 14.7505C16.0002 15.4405 15.4404 16.0003 14.7504 16.0005C14.0602 16.0005 13.5007 15.4406 13.5004 14.7505C13.5004 14.0601 14.0601 13.5005 14.7504 13.5005ZM14.4702 8.47021C14.763 8.17732 15.2378 8.17732 15.5307 8.47021C15.8232 8.76314 15.8234 9.23801 15.5307 9.53076L9.5307 15.5308C9.23795 15.8235 8.76308 15.8232 8.47015 15.5308C8.17726 15.2379 8.17726 14.7631 8.47015 14.4702L14.4702 8.47021ZM9.25043 8.00049C9.94058 8.00072 10.5004 8.56028 10.5004 9.25049C10.5002 9.9405 9.94044 10.5003 9.25043 10.5005C8.56022 10.5005 8.00066 9.94065 8.00043 9.25049C8.00043 8.56013 8.56007 8.00049 9.25043 8.00049Z"
                    [attr.fill]="
                      selectedSection === 'coupons' ? '#307FE1' : 'black'
                    " fill="black" />
                </svg>

                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'coupons'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Coupons & Offers</span>
              </li>
              <li (click)="setSection('notifications')" [ngClass]="
                  selectedSection === 'notifications'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.stroke]="
                      selectedSection === 'notifications' ? '#307FE1' : 'black'
                    "
                    d="M15 17C15 18.6569 13.6569 20 12 20C10.3431 20 9 18.6569 9 17M15 17H18.9151C19.7205 17 20.2444 16.2177 19.8842 15.5528L18.5616 13.1115C17.8093 11.7229 17.4177 10.1918 17.4177 8.63932V8C17.4177 6.3033 16.502 4.80399 15.1018 3.90005C15.0352 3.85708 14.9676 3.81546 14.8989 3.77523C14.0606 3.28429 13.0663 3 12 3C10.9337 3 9.93938 3.28429 9.10113 3.77523C9.03243 3.81546 8.96478 3.85708 8.89823 3.90005C7.49804 4.80399 6.58234 6.3033 6.58234 8V8.63932C6.58234 10.1918 6.19069 11.7229 5.43842 13.1115L4.11579 15.5528C3.75557 16.2177 4.27945 17 5.08493 17H9M15 17H9"
                    stroke="black" stroke-width="1.5" />
                </svg>

                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'notifications'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Notifications and Alerts</span>
              </li>
              <li (click)="setSection('scrap-certificate')" [ngClass]="
                  selectedSection === 'scrap-certificate'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.stroke]="
                      selectedSection === 'scrap-certificate'
                        ? '#307FE1'
                        : 'black'
                    "
                    d="M10 6H14M9 9H15M9.52328 16.2004C9.41649 16.9713 9.65209 17.7824 10.2301 18.3753C11.2058 19.3763 12.7877 19.3763 13.7634 18.3753C14.3413 17.7824 14.5771 16.9711 14.4703 16.2003M9.52328 16.2004C9.59676 15.67 9.83236 15.1587 10.2301 14.7507C11.2058 13.7498 12.7877 13.7498 13.7634 14.7507C14.1611 15.1587 14.3968 15.6699 14.4703 16.2003M9.52328 16.2004L7.76922 18M14.4703 16.2003L16.2245 18M16.2245 18L17.2968 19.1001L15.5301 20.1875L14.4701 21.9999L11.9968 19.4628L9.52341 22L8.46342 20.1877L6.69678 19.1003L7.76922 18M16.2245 18H17C18.1046 18 19 17.1046 19 16V4C19 2.89543 18.1046 2 17 2H7C5.89543 2 5 2.89543 5 4V16C5 17.1046 5.89543 18 7 18H7.76922"
                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'scrap-certificate'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Scrap Certificate</span>
              </li>
              <li (click)="setSection('profile-faq')" [ngClass]="
                  selectedSection === 'profile-faq'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path [attr.stroke]="
                      selectedSection === 'profile-faq' ? '#307FE1' : 'black'
                    "
                    d="M10 15.9424H7.48063C7.17684 15.9424 6.88953 16.0799 6.69976 16.3161L3.89043 19.8122C3.59518 20.1796 3 19.9718 3 19.5012V4.99115C3 3.89147 3.89543 3 5 3H19C20.1046 3 21 3.89147 21 4.99115V10M14.5 13.5H19.5C20.3284 13.5 21 14.1657 21 14.9868V20.5036C21 20.8994 20.5549 21.1355 20.2227 20.9159L18.5038 19.7801C18.1753 19.5631 17.7893 19.4472 17.3944 19.4472H14.5C13.6716 19.4472 13 18.7815 13 17.9604V14.9868C13 14.1657 13.6716 13.5 14.5 13.5Z"
                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'profile-faq'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">
                  FAQ</span>
              </li>
              <li (click)="setSection('customer-support')" [ngClass]="
                  selectedSection === 'customer-support'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.stroke]="
                      selectedSection === 'customer-support'
                        ? '#307FE1'
                        : 'black'
                    "
                    d="M5 11V10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V11M5 11H6.5C6.77614 11 7 11.2239 7 11.5V16.5C7 16.7761 6.77614 17 6.5 17H5C3.89543 17 3 16.1046 3 15V13C3 11.8954 3.89543 11 5 11ZM19 11H17.5C17.2239 11 17 11.2239 17 11.5V16.5C17 16.7761 17.2239 17 17.5 17H18M19 11C20.1046 11 21 11.8954 21 13V15C21 16.1046 20.1046 17 19 17H18M18 17C18 19 16 20 14 20M14 20V19.5C14 19.2239 13.7761 19 13.5 19H12C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21H13.5C13.7761 21 14 20.7761 14 20.5V20Z"
                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'customer-support'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Customer Support</span>
              </li>
              <li (click)="userLogout()" [ngClass]="
                  selectedSection === 'logout'
                    ? 'flex gap-4 items-center p-4 w-full text-blue-500 whitespace-nowrap border-blue-500 border-solid bg-blue-200 bg-opacity-20 border-l-[3px] border-l-[color:var(--Secondary-Blue,#307FE1)] min-h-14 cursor-pointer'
                    : 'flex gap-4 items-center p-4 w-full min-h-14 cursor-pointer'
                ">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/1f4728a69265729638041b0ea0da720e74224e18?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
                  class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" alt="Logout icon" />
                <span class="self-stretch my-auto" [ngClass]="
                    selectedSection === 'logout'
                      ? 'text-blue-500'
                      : 'text-zinc-700'
                  ">Logout</span>
              </li>
            </ul>
          </nav>
        </aside>
      </div>
      <div
        class="right-content w-full md:w-[70%] lg:w-[75%] min-w-0 md:overflow-y-auto md:max-h-[calc(100vh-120px)] pb-8 pr-1">
        <section class="w-full max-w-full max-md:mt-2 max-md:p-0" *ngIf="selectedSection === 'profile'">
          <!-- Business Details -->
          <section class="w-full max-md:max-w-full">
            <header
              class="flex flex-row gap-4 justify-between items-center w-full font-bold max-md:max-w-full md:gap-6">
              <h1 class="self-stretch my-auto text-2xl leading-none text-black max-md:text-base md:text-xl lg:text-2xl">
                Business Details
              </h1>
              <button *ngIf="shouldShowBusinessVerificationButton" type="button"
                (click)="openBusinessVerificationModal()"
                class="flex gap-1 justify-center items-center self-stretch px-3 py-2 my-auto text-sm text-center whitespace-nowrap rounded-lg border border-solid border-[color:var(--Primary-Deep-Blue,#0A0A5F)] min-h-10 text-blue-950 cursor-pointer max-md:justify-end md:text-sm lg:text-base shrink-0">
                {{ businessVerificationLabel }}
              </button>
            </header>

            <div class="grid grid-cols-1 gap-3 mt-6 w-full md:grid-cols-2 md:gap-4">
              <div
                class="flex flex-col justify-between gap-3 p-4 rounded-lg border border-solid border-neutral-300 min-w-0">
                <div class="flex gap-2 justify-between items-center">
                  <span class="text-sm font-bold text-zinc-700">PAN Number</span>
                  <span *ngIf="isPanVerified"
                    class="inline-flex items-center px-2 py-0.5 text-xs font-semibold text-green-700 bg-green-50 rounded-full border border-green-200">
                    Verified
                  </span>
                </div>
                <span class="text-base font-medium text-black break-all uppercase md:text-sm lg:text-base"> <span
                    *ngIf="isPanVerified"
                    class="text-base font-medium text-black break-all uppercase md:text-sm lg:text-base">{{
                    verificationProfile?.account_name}} - </span>{{ verificationProfile?.pan_number || "Not added"
                  }}</span>

              </div>

              <div *ngFor="let type of businessVerificationTypes"
                class="flex flex-col justify-between gap-3 p-4 rounded-lg border border-solid border-neutral-300 min-w-0">
                <div class="flex gap-2 justify-between items-center">
                  <span class="text-sm font-bold text-zinc-700">{{
                    getBusinessStepLabel(type)
                    }}</span>
                  <span *ngIf="isBusinessTypeVerified(type)"
                    class="inline-flex items-center px-2 py-0.5 text-xs font-semibold text-green-700 bg-green-50 rounded-full border border-green-200">
                    Verified
                  </span>
                  <span *ngIf="!isBusinessTypeVerified(type)" class="text-xs font-medium text-zinc-500">Not
                    verified</span>
                </div>

                <span *ngIf="isBusinessTypeVerified(type)"
                  class="text-base font-medium text-black break-all md:text-sm lg:text-base">{{
                  getBusinessTypeSummary(type) }}</span>

                <div *ngIf="!isBusinessTypeVerified(type) && !isFullyBusinessVerified" class="flex gap-2 items-center">
                  <button *ngIf="type === 'udyam' && isPanVerified" type="button" (click)="fetchUdyamFromProfile()"
                    class="flex-1 px-3 py-1.5 text-sm font-bold text-center rounded-lg border border-solid border-[color:var(--Primary-Deep-Blue,#0A0A5F)] text-blue-950 cursor-pointer md:flex-none">
                    Fetch
                  </button>
                  <button type="button" (click)="openBusinessVerificationModal(type)"
                    class="flex-1 px-3 py-1.5 text-sm font-bold text-center rounded-lg border border-solid border-[color:var(--Primary-Deep-Blue,#0A0A5F)] text-blue-950 cursor-pointer md:flex-none">
                    Verify
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="isPanVerified && !isBusinessVerified && !isRouteVerified" class="mt-4 w-full">
              <div
                class="flex gap-3 items-start p-3 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg">
                <svg class="w-5 h-5 shrink-0 mt-0.5 text-amber-600" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v2m0 4h.01M10.29 3.86l-8.5 14.74A1 1 0 002.62 20h18.76a1 1 0 00.87-1.5l-8.5-14.74a1 1 0 00-1.74 0z" />
                </svg>
                <p class="leading-5">
                  PAN is verified. Verify your GSTIN, Udyam or Shop License to
                  complete business verification.
                </p>
              </div>
            </div>

            <div *ngIf="isPanVerified && isBusinessVerified && !canPlaceOrder()" class="mt-4 w-full">
              <div class="flex gap-3 items-start p-3 text-sm text-red-800 bg-red-50 border border-red-200 rounded-lg">
                <svg class="w-5 h-5 shrink-0 mt-0.5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                  aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v2m0 4h.01M10.29 3.86l-8.5 14.74A1 1 0 002.62 20h18.76a1 1 0 00.87-1.5l-8.5-14.74a1 1 0 00-1.74 0z" />
                </svg>
                <p class="leading-5">
                  Your business verification profile is currently inactive. You cannot place orders until it is
                  activated.
                </p>
              </div>
            </div>
          </section>

          <header
            class="flex flex-row gap-10 justify-between items-center w-full font-bold max-md:max-w-full md:gap-6 lg:gap-10 mt-8 pt-8 border-t border-gray-200">
            <h1
              class="self-stretch my-auto text-2xl leading-none text-black max-md:text-[12px] md:text-xl lg:text-2xl whitespace-nowrap">
              <span *ngIf="isEditing"> Edit </span>Personal Details
            </h1>
            <button *ngIf="!isEditing" (click)="toggleEdit()"
              class="flex gap-1 justify-center items-center self-stretch p-2 my-auto text-base text-center whitespace-nowrap rounded-lg border border-solid border-[color:var(--Primary-Deep-Blue,#0A0A5F)] min-h-10 text-blue-950 w-[110px] cursor-pointer max-md:w-full max-md:border-none max-md:justify-end md:w-[100px] lg:w-[110px]">
              <div class="flex gap-2 justify-center items-center self-stretch my-auto">
                <span class="self-stretch my-auto text-blue-950">{{
                  isEditing ? "Cancel" : "Edit"
                  }}</span>
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/086cb6f274cced671a1ba24ef6b2582dc9af0945?placeholderIfAbsent=true&apiKey=7a515686e3e54f1fa59f8a8a2c80ed68"
                  class="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" alt="Edit icon" />
              </div>
            </button>
          </header>

          <form [formGroup]="userForm" class="mt-6 w-full max-md:max-w-full max-md:pb-32 md:mt-4 lg:mt-6">
            <div
              class="flex flex-wrap gap-6 items-start max-w-full w-full max-md:flex-col max-md:w-full md:gap-4 lg:gap-6">
              <div class="grow shrink min-h-16 min-w-60 w-[248px] max-md:w-full md:w-[calc(50%-0.5rem)] lg:w-[248px]">
                <label
                  class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:block max-md:mb-2">
                  First Name
                </label>
                <input type="text" formControlName="firstName" [ngClass]="{
                    'bg-zinc-100': !isEditing || isPanVerified,
                    'border-red-500':
                      isEditing &&
                      !isPanVerified &&
                      userForm.get('firstName')?.invalid &&
                      userForm.get('firstName')?.touched,
                  }" [disabled]="!isEditing || isPanVerified" (input)="onNameInput($event, 'firstName')"
                  class="flex flex-1 gap-2 items-center p-2 mt-1 text-base font-medium text-black whitespace-nowrap rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] size-full max-md:w-full max-md:p-3 md:p-2 md:text-sm lg:p-2 lg:text-base" />
                <div *ngIf="
                    isEditing &&
                    userForm.get('firstName')?.invalid &&
                    userForm.get('firstName')?.touched
                  " class="text-red-500 text-xs mt-1">
                  <span *ngIf="userForm.get('firstName')?.errors?.['required']">First Name is required</span>
                  <span *ngIf="userForm.get('firstName')?.errors?.['pattern']">Only alphabets allowed</span>
                </div>
              </div>
              <div class="grow shrink min-h-16 min-w-60 w-[248px] max-md:w-full md:w-[calc(50%-0.5rem)] lg:w-[248px]">
                <label
                  class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:block max-md:mb-2">
                  Last Name
                </label>
                <input type="text" formControlName="lastName" [ngClass]="{
                    'bg-zinc-100': !isEditing || isPanVerified,
                    'border-red-500':
                      isEditing &&
                      !isPanVerified &&
                      userForm.get('lastName')?.invalid &&
                      userForm.get('lastName')?.touched,
                  }" [disabled]="!isEditing || isPanVerified" (input)="onNameInput($event, 'lastName')"
                  class="flex flex-1 gap-2 items-center p-2 mt-1 text-base font-medium text-black whitespace-nowrap rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] size-full max-md:w-full max-md:p-3 md:p-2 md:text-sm lg:p-2 lg:text-base" />
                <div *ngIf="
                    isEditing &&
                    userForm.get('lastName')?.invalid &&
                    userForm.get('lastName')?.touched
                  " class="text-red-500 text-xs mt-1">
                  <span *ngIf="userForm.get('lastName')?.errors?.['required']">Last Name is required</span>
                  <span *ngIf="userForm.get('lastName')?.errors?.['pattern']">Only alphabets allowed</span>
                </div>
              </div>
            </div>

            <div
              class="flex flex-wrap gap-6 items-start mt-4 w-full max-md:max-w-full max-md:flex-col md:gap-4 lg:gap-6">
              <div class="grow shrink min-h-16 min-w-60 w-[248px] max-md:w-full md:w-[calc(50%-0.5rem)] lg:w-[248px]">
                <div class="flex justify-between items-center max-md:mb-2">
                  <label class="text-sm font-semibold text-zinc-700">
                    Mobile Number
                  </label>
                  <button *ngIf="isEditing" type="button"
                    class="text-xs font-medium text-blue-500 hover:underline cursor-pointer" [disabled]="!isEditing"
                    (click)="openUpdateMobileModal('mobile')">
                    Update
                  </button>
                </div>
                <input type="tel" formControlName="mobileNumber" [disabled]="true"
                  class="flex flex-1 gap-2 items-center p-2 mt-1 text-base font-medium text-black whitespace-nowrap rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] size-full bg-zinc-100 max-md:w-full max-md:p-3 md:p-2 md:text-sm lg:p-2 lg:text-base" />
              </div>
              <div class="grow shrink min-h-16 min-w-60 w-[248px] max-md:w-full md:w-[calc(50%-0.5rem)] lg:w-[248px]">
                <div class="flex justify-between items-center max-md:mb-2">
                  <label class="text-sm font-semibold text-zinc-700">
                    Email ID
                  </label>

                  <button *ngIf="!email_id && userForm.get('emailId')?.value" type="button"
                    class="text-xs font-medium text-blue-500 hover:underline cursor-pointer"
                    [disabled]="!isEditing || !userForm.get('emailId')?.valid" (click)="openverifyMobileModal()">
                    verify
                  </button>

                  <button *ngIf="email_id && isEditing" type="button"
                    class="text-xs font-medium text-blue-500 hover:underline cursor-pointer" [disabled]="!isEditing"
                    (click)="openUpdateMobileModal('email')">
                    Update
                  </button>

                  <span *ngIf="!email_id && !userForm.get('emailId')?.value"
                    class="text-xs font-medium text-zinc-700">(Optional)</span>
                </div>
                <input type="email" formControlName="emailId" placeholder="Enter email id"
                  [disabled]="!isEditing || email_id" (input)="onEmailInputChange($event)" (blur)="onEmailFieldBlur()"
                  class="flex flex-1 gap-2 items-center p-2 mt-1 text-base font-medium text-black whitespace-nowrap rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] size-full max-md:w-full max-md:p-3 md:p-2 md:text-sm lg:p-2 lg:text-base"
                  [ngClass]="{ 'bg-zinc-100': !isEditing || email_id }" />
                <div *ngIf="
                    userForm.get('emailId')?.invalid &&
                    userForm.get('emailId')?.touched
                  " class="text-xs text-red-500 mt-1">
                  Please enter a valid email address
                </div>
              </div>
            </div>

            <div
              class="flex flex-wrap gap-6 justify-between items-start mt-4 w-full max-md:max-w-full max-md:flex-col md:gap-4 lg:gap-6">
              <!-- <div class="min-h-16 min-w-60 w-[310px] max-md:w-full md:w-[calc(50%-0.5rem)] lg:w-[310px]">
                                <label
                                    class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:block max-md:mb-2">
                                    Date of Birth
                                </label>
                                <div class="relative">
                                    <input type="date" formControlName="dateOfBirth" placeholder="Add your birth date"
                                        [ngClass]="{'bg-zinc-100': !isEditing}" [disabled]="!isEditing" [max]="today"
                                        class="w-full pl-4 py-2 border border-gray-300 rounded-md text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 max-md:p-3 max-md:rounded-lg" />
                                </div>
                            </div> -->

              <div class="min-h-16 min-w-60 w-[310px] max-md:w-full md:w-[calc(50%-0.5rem)] lg:w-[310px]">
                <!-- Label -->
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Date of Birth
                </label>

                <!-- Input Wrapper -->
                <div class="relative date-picker-input-container">
                  <input type="text" [value]="getDisplayDate()" placeholder="Add your birth date"
                    (click)="openDatePicker()" [readonly]="true" [ngClass]="{
                      'bg-zinc-100': !isEditing,
                      'cursor-not-allowed': !isEditing,
                      'cursor-pointer': isEditing,
                    }" [disabled]="!isEditing"
                    class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-md text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 md:text-sm md:py-2 lg:text-base lg:py-2" />

                  <!-- Custom Calendar Icon -->
                  <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" fill="none"
                      viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10m-12 8h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>

                  <!-- Desktop Calendar Dropdown (relative to input) -->
                  <div *ngIf="showDatePicker" #datePickerContainer
                    class="hidden md:block absolute top-full left-0 mt-1 w-[350px] bg-white rounded-lg shadow-lg border border-gray-200 z-50 max-h-[400px] overflow-hidden">
                    <!-- Calendar Header -->
                    <div class="flex justify-between items-center p-4 border-b border-gray-200 bg-white">
                      <div class="flex items-center gap-2">
                        <button (click)="previousMonth()" class="p-1 hover:bg-gray-100 rounded">
                          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                            </path>
                          </svg>
                        </button>
                        <div class="flex items-center gap-1">
                          <span class="text-lg font-semibold text-gray-900">{{
                            getCurrentMonthYear()
                            }}</span>
                          <button (click)="toggleMonthYearPicker()" class="p-1 hover:bg-gray-100 rounded">
                            <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                              </path>
                            </svg>
                          </button>
                        </div>
                        <button (click)="nextMonth()" class="p-1 hover:bg-gray-100 rounded">
                          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7">
                            </path>
                          </svg>
                        </button>
                      </div>
                      <button (click)="closeDatePicker()" class="text-gray-400 hover:text-gray-600">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                      </button>
                    </div>

                    <!-- Month/Year Picker (when toggled) -->
                    <div *ngIf="showMonthYearPicker" class="p-4 border-b border-gray-200">
                      <div class="grid grid-cols-3 gap-2">
                        <select [(ngModel)]="selectedYear" (change)="onYearChange()"
                          class="p-2 border border-gray-300 rounded">
                          <option *ngFor="let year of availableYears" [value]="year">
                            {{ year }}
                          </option>
                        </select>
                        <select [(ngModel)]="selectedMonth" (change)="onMonthChange()"
                          class="p-2 border border-gray-300 rounded col-span-2">
                          <option *ngFor="let month of monthNames; let i = index" [value]="i">
                            {{ month }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Calendar Grid -->
                    <div class="p-4">
                      <!-- Days of Week Header -->
                      <div class="grid grid-cols-7 gap-1 mb-2">
                        <div *ngFor="let day of dayNames" class="text-center text-sm font-medium text-gray-500 py-2">
                          {{ day }}
                        </div>
                      </div>

                      <!-- Calendar Days -->
                      <div class="grid grid-cols-7 gap-1">
                        <div *ngFor="let day of calendarDays"
                          class="text-center py-2 rounded cursor-pointer transition-colors" [ngClass]="{
                            'text-gray-400': day.isOtherMonth,
                            'text-gray-900 hover:bg-gray-100':
                              !day.isOtherMonth &&
                              !day.isSelected &&
                              !day.isToday,
                            'bg-blue-500 text-white font-semibold':
                              day.isSelected,
                            'bg-blue-100 text-blue-700 font-semibold':
                              day.isToday && !day.isSelected,
                            'opacity-50 cursor-not-allowed': day.isDisabled,
                          }" (click)="selectDateAndClose(day)" [class.pointer-events-none]="day.isDisabled">
                          {{ day.date }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="min-h-16 min-w-60 w-[310px] max-md:w-full md:w-[calc(50%-0.5rem)] lg:w-[310px]">
                <label
                  class="flex-1 shrink gap-2.5 self-stretch w-full text-sm font-bold leading-none basis-0 text-zinc-700 max-md:block max-md:mb-2">
                  Who are you
                </label>
                <!-- Desktop dropdown -->
                <select formControlName="userType" [ngClass]="{ 'bg-zinc-100': !isEditing }" [disabled]="!isEditing"
                  class="hidden md:block w-full p-2 mt-1 text-base font-medium text-black whitespace-nowrap rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] md:text-sm md:p-2 lg:text-base lg:p-2">
                  <option *ngFor="let option of userTypeOptions" [value]="option">
                    {{ option }}
                  </option>
                </select>

                <!-- Mobile custom dropdown trigger -->
                <div class="block md:hidden">
                  <button type="button" (click)="openUserTypeDropdown()" [disabled]="!isEditing"
                    class="w-full p-3 mt-1 text-base font-medium text-black rounded-lg border border-solid border-[color:var(--Input-field-Stroke,#D4D4D4)] text-left flex justify-between items-center"
                    [ngClass]="{ 'bg-zinc-100': !isEditing }">
                    <span>{{
                      userForm.get("userType")?.value || "Select user type"
                      }}</span>
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <footer *ngIf="isEditing"
              class="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 p-4 max-md:px-4 max-md:py-3 md:relative md:mt-5 md:border-t-0 md:p-0 lg:mt-7">
              <div
                class="flex flex-wrap gap-6 items-center w-full text-base font-bold text-center max-md:max-w-full max-md:gap-3 md:gap-4 lg:gap-6">
                <button type="button" (click)="toggleEdit()"
                  class="flex flex-1 shrink gap-1 justify-center items-center self-stretch p-3 my-auto whitespace-nowrap rounded-lg border border-solid basis-0 border-[color:var(--Primary-Deep-Blue,#0A0A5F)] min-w-60 text-blue-950 max-md:w-full max-md:min-w-0 max-md:py-2 md:p-2 md:text-sm lg:p-3 lg:text-base">
                  <span class="gap-2 self-stretch my-auto text-blue-950">Cancel</span>
                </button>
                <button type="submit" (click)="updateUserDetails()"
                  class="flex flex-1 shrink gap-1 justify-center items-center self-stretch p-3 my-auto text-white rounded-lg basis-0 bg-blue-950 min-w-60 max-md:w-full max-md:min-w-0 max-md:py-2 md:p-2 md:text-sm lg:p-3 lg:text-base"
                  [ngClass]="{
                    'bg-gray-300 cursor-not-allowed': userForm.invalid,
                  }">
                  <span class="gap-2 self-stretch my-auto text-white">Save Changes</span>
                </button>
              </div>
            </footer>
          </form>
        </section>
        <app-orders *ngIf="selectedSection === 'orders'"></app-orders>
        <app-user-address [isStandalone]="false" *ngIf="selectedSection === 'address'"></app-user-address>
        <app-wishlist [isStandalone]="false" *ngIf="selectedSection === 'wishlist'"></app-wishlist>
        <app-notification-alert [isStandalone]="false"
          *ngIf="selectedSection === 'notifications'"></app-notification-alert>
        <app-coupons-offers [isStandalone]="false" *ngIf="selectedSection === 'coupons'"></app-coupons-offers>
        <app-scrap-certificate [isStandalone]="false"
          *ngIf="selectedSection === 'scrap-certificate'"></app-scrap-certificate>
        <app-my-garage [isStandalone]="false" *ngIf="selectedSection === 'my-garage'"></app-my-garage>
        <app-profile-faq [isStandalone]="false" *ngIf="selectedSection === 'profile-faq'"></app-profile-faq>
        <app-customer-support [isStandalone]="false"
          *ngIf="selectedSection === 'customer-support'"></app-customer-support>
      </div>
    </div>
  </main>
</div>

<!-- Mobile User Type Dropdown Modal -->
<div *ngIf="showUserTypeDropdown" class="fixed inset-0 z-50 flex items-end justify-center md:hidden">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black bg-opacity-50" (click)="closeUserTypeDropdown()"></div>

  <!-- Modal Content -->
  <div class="relative w-full bg-white rounded-t-2xl shadow-lg max-h-[80vh] overflow-hidden flex flex-col">
    <!-- Header -->
    <div class="flex justify-between items-center p-4 border-b border-gray-200 bg-white sticky top-0">
      <h3 class="text-lg font-semibold text-blue-950">Select Any One</h3>
      <button (click)="closeUserTypeDropdown()" class="text-blue-950 hover:text-blue-800">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Options List -->
    <div class="max-h-[60vh] overflow-y-auto">
      <div>
        <div *ngFor="let option of userTypeOptions; let last = last"
          class="p-4 cursor-pointer hover:bg-gray-50 transition-colors"
          [ngClass]="{ 'border-b border-gray-200': !last }" (click)="selectUserTypeOption(option)">
          <span class="text-base font-medium text-black" [ngClass]="{
              'text-blue-950 font-semibold': selectedUserType === option,
            }">
            {{ option }}
          </span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-4 py-4 border-t border-gray-200 bg-white">
      <div class="flex gap-3">
        <button (click)="closeUserTypeDropdown()"
          class="flex-1 py-3 px-4 bg-white border border-blue-950 text-blue-950 font-medium rounded-lg hover:bg-blue-50">
          Back
        </button>
        <button (click)="confirmUserTypeSelection()" [disabled]="!selectedUserType"
          class="flex-1 py-3 px-4 bg-blue-950 text-white font-medium rounded-lg hover:bg-blue-900 disabled:bg-gray-300 disabled:cursor-not-allowed">
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Update Mobile Number Modal/Drawer -->
<div *ngIf="showUpdateMobileModal"
  class="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-30 max-md:items-end max-md:justify-center md:justify-end lg:justify-end">
  <div
    class="bg-white w-[420px] h-full shadow-lg flex flex-col relative animate-slide-in-right max-md:w-full max-md:h-auto max-md:max-h-[80vh] max-md:rounded-t-2xl md:w-[400px] lg:w-[420px]">
    <!-- Close button -->
    <button class="absolute top-4 right-4 text-2xl z-10" (click)="closeUpdateMobileModal()">
      ×
    </button>

    <!-- Scrollable content area -->
    <div class="flex-1 overflow-y-auto p-8 max-md:p-6 md:p-6 lg:p-8">
      <h2 class="text-2xl font-bold text-blue-950 mt-[-10px] md:text-xl lg:text-2xl">
        Update <span *ngIf="updatePopupMethod === 'mobile'">Mobile Number</span>
        <span *ngIf="updatePopupMethod === 'email'">Email ID</span>
      </h2>
      <p class="mb-6 font-medium md:text-sm md:mb-4 lg:text-base lg:mb-6">
        To update your
        <span *ngIf="updatePopupMethod === 'mobile'">mobile number</span>
        <span *ngIf="updatePopupMethod === 'email'">email ID</span>, you need to
        go through these steps
      </p>
      <ol class="relative pl-6">
        <!-- Step 1 - Completed -->
        <li class="relative pt-0 pr-[7px] pb-2 pl-9 border-l border-gray-300">
          <div class="absolute -left-[9px] w-4 h-4 bg-gray-300 rounded-full"></div>

          <h3 class="text-sm font-bold text-black">Verify Existing Account</h3>
          <p class="text-sm text-gray-500">
            An OTP will be sent to your registered no. or email for
            verification.
          </p>
        </li>

        <!-- Step 2 - Active -->
        <li class="relative pt-0 pr-[7px] pb-2 pl-9 border-l border-gray-300">
          <div class="absolute -left-[9px] w-4 h-4 bg-gray-300 rounded-full"></div>

          <h3 class="text-sm font-bold text-black">
            Enter
            <span *ngIf="updatePopupMethod === 'mobile'"> New Number</span>
            <span *ngIf="updatePopupMethod === 'email'">New Email ID</span>
          </h3>
          <p class="text-sm text-gray-500">
            Provide your new
            <span *ngIf="updatePopupMethod === 'mobile'">mobile number</span>
            <span *ngIf="updatePopupMethod === 'email'">email ID</span>
          </p>
        </li>

        <!-- Step 3 - Upcoming (no border on last step) -->
        <li class="relative pt-0 pr-[7px] pb-2 pl-9">
          <div class="absolute -left-[9px] w-4 h-4 bg-gray-300 rounded-full"></div>
          <h3 class="text-sm font-bold text-black">
            Verify
            <span *ngIf="updatePopupMethod === 'mobile'">New Number</span>
            <span *ngIf="updatePopupMethod === 'email'">New Email ID</span>
          </h3>
          <p class="text-sm text-gray-500">
            An OTP will be sent to your new
            <span *ngIf="updatePopupMethod === 'mobile'">mobile number</span>
            <span *ngIf="updatePopupMethod === 'email'">email ID</span> for
            verification
          </p>
        </li>
      </ol>

      <div class="mb-6">
        <div class="font-semibold mb-2">
          How would you like to update
          <span *ngIf="updatePopupMethod === 'mobile'">mobile number</span>
          <span *ngIf="updatePopupMethod === 'email'">email ID</span>?
        </div>
        <label class="flex items-center mb-2 cursor-pointer">
          <input type="radio" name="verifyMethod" value="mobile" [(ngModel)]="selectedVerificationMethod" />
          <span class="ml-2">{{
            user?.phone_number || "No mobile number available"
            }}</span>
        </label>
        <label class="flex items-center cursor-pointer">
          <input type="radio" name="verifyMethod" value="email" [(ngModel)]="selectedVerificationMethod" />
          <span class="ml-2">{{ user?.email_id || "No email available" }}</span>
        </label>
      </div>
    </div>

    <!-- Fixed footer with buttons -->
    <div class="p-2 border-t border-gray-200 bg-white max-md:p-6">
      <div class="flex justify-between gap-4">
        <button class="border border-blue-950 text-blue-950 px-16 py-3 rounded hover:bg-blue-50 transition-colors"
          (click)="closeUpdateMobileModal()">
          Back
        </button>
        <button class="bg-blue-950 text-white px-16 py-3 rounded hover:bg-blue-900 transition-colors"
          (click)="proceedUpdateMobile()">
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>

<!-- OTP Modal Popup (on top of right drawer) -->
<div *ngIf="showOtpModal"
  class="fixed inset-0 z-[60] flex justify-end bg-black bg-opacity-40 max-md:items-end max-md:justify-center md:justify-end lg:justify-end">
  <div
    class="bg-white w-[420px] h-full shadow-lg flex flex-col relative animate-slide-in-right max-md:w-full max-md:h-auto max-md:max-h-[80vh] max-md:rounded-t-2xl md:w-[400px] lg:w-[420px]">
    <!-- Fixed Header -->
    <div
      class="flex items-center justify-between px-8 py-4 border-b border-gray-200 max-md:px-6 max-md:py-4 md:px-6 md:py-3 lg:px-8 lg:py-4">
      <h2 class="text-xl font-bold text-blue-950 max-md:text-lg md:text-lg lg:text-xl max-md:text-start">
        <span *ngIf="step === 1">Verify Existing Account</span>
        <span *ngIf="step === 2">Add New
          <span *ngIf="updatePopupMethod === 'mobile'">Mobile Number</span><span
            *ngIf="updatePopupMethod === 'email'">Email ID</span></span>
        <span *ngIf="step === 3">Verify New
          <span *ngIf="updatePopupMethod === 'mobile'">Mobile Number</span><span
            *ngIf="updatePopupMethod === 'email'">Email ID</span></span>
      </h2>
      <button class="text-2xl text-gray-500 hover:text-gray-700" (click)="closeOtpModal()">
        ×
      </button>
    </div>

    <!-- Scrollable Content -->
    <div class="flex-1 overflow-y-auto px-8 py-6 max-md:px-6 max-md:py-4 md:px-6 md:py-4 lg:px-8 lg:py-6">
      <!-- Stepper -->
      <div class="flex items-start w-full justify-between relative max-md:mb-8 max-md:gap-2 md:gap-4">
        <!-- Gray background line -->
        <div
          class="absolute top-[10px] left-[10px] right-[10px] h-[1px] bg-gray-300 z-0 max-md:left-[12px] max-md:right-[12px]">
        </div>

        <!-- Blue progress line -->
        <div
          class="absolute top-[10px] left-[10px] h-[1px] bg-blue-500 z-10 transition-all duration-300 max-md:left-[12px]"
          [ngStyle]="{
            width:
              step === 1
                ? '0%'
                : step === 2
                  ? 'calc(50% - 10px)'
                  : 'calc(100% - 20px)',
          }" [ngClass]="{
            'max-md:w-[calc(50%-12px)]': step === 2,
            'max-md:w-[calc(100%-24px)]': step === 3,
          }"></div>

        <!-- Step 1 -->
        <div class="flex flex-col items-start z-10 flex-1 max-md:flex-1">
          <div class="w-5 h-5 rounded-full relative" [ngClass]="{
              'border-2 border-blue-500 bg-white': step === 1,
              'bg-blue-500': step > 1,
              'bg-gray-300': step < 1,
            }">
            <div *ngIf="step > 1" class="flex items-center justify-center h-full text-white text-xs">
              ✓
            </div>
          </div>
          <span class="mt-2 text-[12px] max-md:text-xs max-md:px-1 text-start" [ngClass]="{
              'font-semibold text-black': step === 1,
              'text-blue-500': step > 1,
              'text-gray-500': step < 1,
            }">
            Verify Existing Account
          </span>
        </div>

        <!-- Step 2 -->
        <div class="flex flex-col items-center z-10 flex-1 max-md:flex-1">
          <div class="w-5 h-5 rounded-full relative" [ngClass]="{
              'border-2 border-blue-500 bg-white': step === 2,
              'bg-blue-500': step > 2,
              'bg-gray-300': step < 2,
            }">
            <div *ngIf="step > 2" class="flex items-center justify-center h-full text-white text-xs">
              ✓
            </div>
          </div>
          <span class="mt-2 text-[12px] text-center max-md:text-xs max-md:px-1 max-md:text-start" [ngClass]="{
              'font-semibold text-black': step === 2,
              'text-blue-500': step > 2,
              'text-gray-500': step < 2,
            }">
            Enter <span *ngIf="updatePopupMethod === 'mobile'">new number</span>
            <span *ngIf="updatePopupMethod === 'email'">new email ID</span>
          </span>
        </div>

        <!-- Step 3 -->
        <div class="flex flex-col items-end z-10 flex-1 max-md:flex-1">
          <div class="w-5 h-5 rounded-full relative" [ngClass]="{
              'border-2 border-blue-500 bg-white': step === 3,
              'bg-blue-500': step > 3,
              'bg-gray-300': step < 3,
            }">
            <div *ngIf="step > 3" class="flex items-center justify-center h-full text-white text-xs">
              ✓
            </div>
          </div>
          <span class="mt-2 text-[12px] max-md:text-xs max-md:px-1 text-end" [ngClass]="{
              'font-semibold text-black': step === 3,
              'text-blue-500': step > 3,
              'text-gray-500': step < 3,
            }">
            Verify
            <span *ngIf="updatePopupMethod === 'mobile'">new number</span>
            <span *ngIf="updatePopupMethod === 'email'">new email ID</span>
          </span>
        </div>
      </div>

      @if (step === 1) {
      <div class="mt-8 mb-4 font-bold text-lg max-md:mt-6 max-md:mb-4 max-md:text-center max-md:text-start">
        OTP verification required
      </div>
      <div class="mb-6 text-sm text-gray-600 max-md:mb-6 max-md:text-center max-md:text-start">
        To update your
        <span *ngIf="updatePopupMethod === 'mobile'">mobile number</span><span
          *ngIf="updatePopupMethod === 'email'">email ID</span>, please
        enter the OTP sent to your
        <span class="font-semibold" *ngIf="selectedVerificationMethod === 'mobile'">{{ user?.phone_number }}</span><span
          class="font-semibold" *ngIf="selectedVerificationMethod === 'email'">{{ user?.email_id }}</span>.
      </div>

      <form [formGroup]="otpForm" class="flex gap-4 justify-center max-md:gap-3 max-md:justify-start">
        <ng-container *ngFor="let controlName of otpControls; let i = index">
          <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="1"
            class="w-12 h-12 text-center text-xl border rounded-lg focus:outline-none focus:ring-2 transition-all max-md:w-12 max-md:h-12 max-md:text-lg"
            [ngClass]="{
                'border-gray-300 focus:border-blue-500 focus:ring-blue-200':
                  !isOtpInvalid &&
                  (!otpForm.get(controlName)?.touched ||
                    otpForm.get(controlName)?.valid),
                'border-red-500 focus:ring-red-200 bg-red-50':
                  isOtpInvalid ||
                  (otpForm.get(controlName)?.touched &&
                    otpForm.get(controlName)?.invalid),
              }" [formControlName]="controlName" (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)"
            #otpInput autocomplete="off" [attr.data-index]="i" />
        </ng-container>
      </form>
      <div class="text-red-500 text-sm text-center max-md:text-start" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="flex justify-center mt-4 max-md:justify-start max-md:mt-6">
        <button type="button" class="text-sm font-medium transition-colors" [disabled]="otpTimer > 0"
          (click)="updateSendOtp()" [ngClass]="
              otpTimer > 0
                ? 'text-gray-500 cursor-not-allowed select-none'
                : 'text-blue-500 hover:underline cursor-pointer'
            ">
          <ng-container *ngIf="otpTimer > 0">
            Resend OTP in
            <span class="font-semibold">00:{{ otpTimer < 10 ? "0" + otpTimer : otpTimer }}</span>
          </ng-container>
          <ng-container class="text-blue-950" *ngIf="otpTimer === 0">
            Resend OTP
          </ng-container>
        </button>
      </div>
      } @else if (step === 2) {
      <div class="mt-8 mb-4 font-bold text-lg max-md:mt-4 max-md:mb-4 max-md:text-start max-md:text-xl">
        Enter
        <span *ngIf="updatePopupMethod === 'mobile'">new mobile number</span>
        <span *ngIf="updatePopupMethod === 'email'">new email ID</span>
      </div>
      <div class="mb-6 text-sm text-gray-600 max-md:mb-4 max-md:text-start max-md:text-base">
        Please provide the
        <span *ngIf="updatePopupMethod === 'mobile'">mobile number</span>
        <span *ngIf="updatePopupMethod === 'email'">email ID</span> you'd like
        to use going forward.
      </div>
      <div class="max-w-[436px] mx-auto max-md:max-w-full max-md:px-0">
        <label for="mobile-input"
          class="block text-sm font-bold text-zinc-700 mb-3 max-md:text-start max-md:text-base max-md:mb-4">
          <span *ngIf="updatePopupMethod === 'mobile'">Mobile Number</span>
          <span *ngIf="updatePopupMethod === 'email'">Email ID</span>
        </label>
        <div
          class="flex items-center gap-2 p-3 border border-[#D4D4D4] rounded-lg text-base font-medium text-black bg-white max-md:p-1 max-md:border-2 max-md:border-gray-300 outline-none">
          <input id="mobile-input" type="tel" placeholder="Enter mobile number" *ngIf="updatePopupMethod === 'mobile'"
            maxlength="10" pattern="^[6-9]\d{9}$"
            class="flex-1 w-full bg-transparent border-none outline-none focus:ring-0 bg-transparent text-black placeholder-gray-400 max-md:text-lg max-md:py-2"
            aria-label="Mobile Number" [placeholder]="'Enter new mobile number'" #mobileInput
            (input)="onMobileInputChange($event)" (blur)="validateMobile(mobileInput.value)" />

          <input id="email-input" type="email" placeholder="Enter your updated email ID"
            *ngIf="updatePopupMethod === 'email'" maxlength="50"
            class="flex-1 w-full bg-transparent border-none outline-none focus:ring-0 bg-transparent text-black placeholder-gray-400 max-md:text-lg max-md:py-2"
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" aria-label="Email ID"
            [placeholder]="'Enter new email ID'" #emailInput (input)="onEmailInputChange($event)"
            (blur)="validateEmail(emailInput.value)" />
        </div>
        <!-- <div *ngIf="showError" class="text-red-500 text-sm mt-1">
                            Please enter a valid email address
                        </div> -->

        <!-- Mobile error -->
        <!-- <div *ngIf="updatePopupMethod === 'mobile' && newMobileControl.touched && newMobileControl.invalid"
     class="text-red-500 text-sm mt-1">
  Please enter a valid mobile number
</div>

Email error -->
        <!-- <div *ngIf="updatePopupMethod === 'email' && newEmailControl.touched && newEmailControl.invalid"
     class="text-red-500 text-sm mt-1">
  Please enter a valid email address
</div> -->
        <div *ngIf="updatePopupMethod === 'mobile' && showMobileError"
          class="text-red-500 text-sm mt-1 max-md:text-start">
          Please enter a valid mobile number
        </div>
        <div *ngIf="errorMessage && !showMobileError" class="text-red-500 text-sm mt-1 max-md:text-start">
          {{ errorMessage }}
        </div>

        <div *ngIf="updatePopupMethod === 'email' && showEmailError"
          class="text-red-500 text-sm mt-1 max-md:text-start">
          Please enter a valid email address
        </div>
      </div>
      } @else if (step === 3) {
      <div class="mt-8 mb-4 font-bold text-lg max-md:mt-6 max-md:mb-4 max-md:text-start">
        OTP verification required
      </div>
      <div class="mb-6 text-sm text-gray-600 max-md:mb-6 max-md:text-start">
        Please enter the OTP sent to your new
        <span *ngIf="updatePopupMethod === 'mobile'">mobile number</span><span
          *ngIf="updatePopupMethod === 'email'">email ID</span>
        <span class="font-semibold">{{ newMobileNumber || newEmailId }}</span>.
      </div>

      <form [formGroup]="otpForm" class="flex gap-4 justify-center max-md:gap-3 max-md:justify-start">
        <ng-container *ngFor="let controlName of otpControls; let i = index">
          <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="1"
            class="w-12 h-12 text-center text-xl border rounded-lg focus:outline-none focus:ring-2 transition-all max-md:w-12 max-md:h-12 max-md:text-lg"
            [ngClass]="{
                'border-gray-300 focus:border-blue-500 focus:ring-blue-200':
                  !isOtpInvalid &&
                  (!otpForm.get(controlName)?.touched ||
                    otpForm.get(controlName)?.valid),
                'border-red-500 focus:ring-red-200 bg-red-50':
                  isOtpInvalid ||
                  (otpForm.get(controlName)?.touched &&
                    otpForm.get(controlName)?.invalid),
              }" [formControlName]="controlName" (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)"
            #otpInput autocomplete="off" [attr.data-index]="i" />
        </ng-container>
      </form>
      <div class="text-red-500 text-sm text-center max-md:text-start" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="flex justify-start mt-4 max-md:justify-start max-md:mt-6 max-md:text-start">
        <button type="button" class="text-sm font-medium transition-colors" [disabled]="otpTimer > 0"
          (click)="onResendClick()" [ngClass]="
              otpTimer > 0
                ? 'text-gray-500 cursor-not-allowed select-none opacity-60'
                : 'text-blue-500 hover:underline cursor-pointer'
            ">
          <ng-container *ngIf="otpTimer > 0">
            Resend OTP in
            <span class="font-semibold">00:{{ otpTimer < 10 ? "0" + otpTimer : otpTimer }}</span>
          </ng-container>
          <ng-container class="text-blue-500" *ngIf="otpTimer === 0">
            Resend OTP
          </ng-container>
        </button>
      </div>
      }
    </div>

    <!-- Fixed Footer -->
    <div class="px-8 py-4 border-t border-gray-200 max-md:px-6 max-md:py-4">
      <div class="flex justify-between max-md:gap-3">
        <button
          class="px-8 py-2 border border-blue-950 text-blue-950 rounded hover:bg-blue-50 transition-colors max-md:flex-1 max-md:py-3"
          (click)="handleBackButton()">
          {{ step > 1 ? "Back" : "Cancel" }}
        </button>
        <button class="px-8 py-2 bg-blue-950 text-white rounded transition-colors max-md:flex-1 max-md:py-3" [ngClass]="{
            'hover:bg-blue-900': !isButtonDisabled(),
            'opacity-50 cursor-not-allowed': isButtonDisabled(),
          }" [attr.aria-disabled]="isButtonDisabled()" [disabled]="isButtonDisabled()" (click)="verifyOtp()">
          {{ btnLabel }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Email Verification Modal -->
<div *ngIf="showEmailVerifyModal"
  class="fixed inset-0 z-[9999] flex justify-end bg-black bg-opacity-30 max-md:items-end max-md:justify-center md:justify-end lg:justify-end">
  <!-- Desktop: Right side drawer, Mobile: Bottom sheet -->
  <div
    class="bg-white w-[420px] h-full shadow-lg flex flex-col relative animate-slide-in-right max-md:w-full max-md:h-auto max-md:max-h-[80vh] max-md:rounded-t-2xl md:w-[400px] lg:w-[420px]">
    <!-- Header -->
    <div class="flex items-center justify-between px-8 py-4 border-b border-gray-200 max-md:text-start">
      <h2 class="text-xl font-bold text-blue-950">Verify Email ID</h2>
      <button class="text-2xl text-gray-500 hover:text-gray-700" (click)="closeEmailVerifyModal()">
        ×
      </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto px-8 py-6 max-md:text-start">
      <div class="text-center max-md:text-start">
        <h3 class="text-lg font-bold text-black mb-2">
          OTP verification required
        </h3>
        <p class="text-sm text-gray-600 mb-8">
          To verify email id please enter the OTP sent to
          <span class="font-semibold">{{
            userForm.get("emailId")?.value || "your email"
            }}</span>.
        </p>

        <!-- OTP Input Fields -->
        <form [formGroup]="emailOtpForm" class="flex gap-4 justify-center mb-8 max-md:justify-start">
          <ng-container *ngFor="let controlName of emailOtpControls; let i = index">
            <input type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="1" [class]="
                emailOtpError
                  ? 'w-12 h-12 text-center text-xl border border-red-500 bg-red-50 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-200 focus:border-red-500 transition-all'
                  : 'w-12 h-12 text-center text-xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500 transition-all'
              " [formControlName]="controlName" (input)="onEmailOtpInput($event, i)"
              (keydown)="onEmailOtpKeyDown($event, i)" autocomplete="off" [attr.data-email-index]="i" />
          </ng-container>
        </form>
        <div class="text-red-500 text-sm max-md:text-start" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
        <!-- Timer -->
        <button type="button" class="text-sm font-medium transition-colors" [disabled]="emailOtpTimer > 0"
          (click)="resendEmailOtp()" [ngClass]="
            emailOtpTimer > 0
              ? 'text-gray-500 cursor-not-allowed select-none'
              : 'text-blue-600 hover:underline cursor-pointer'
          ">
          <ng-container *ngIf="emailOtpTimer > 0">
            Resend OTP in
            <span class="font-semibold">00:{{
              emailOtpTimer < 10 ? "0" + emailOtpTimer : emailOtpTimer }}</span>
          </ng-container>
          <ng-container class="text-blue-950" *ngIf="emailOtpTimer === 0">
            Resend OTP
          </ng-container>
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-8 py-4 border-t border-gray-200">
      <div class="flex justify-between gap-4">
        <button (click)="closeEmailVerifyModal()"
          class="flex-1 py-3 px-4 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors">
          Cancel
        </button>
        <button (click)="verifyEmailOtp()" [disabled]="!emailOtpForm.valid"
          class="flex-1 py-3 px-4 bg-blue-950 text-white font-medium rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors">
          Verify
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Logout Confirmation Popup -->
<div *ngIf="showLogoutPopup" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 relative">
    <!-- Close button -->
    <button (click)="cancelLogout()" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>

    <!-- Header -->
    <div class="px-6 pt-6 pb-4">
      <h3 class="text-xl font-bold text-gray-900">Logout</h3>
    </div>

    <!-- Content -->
    <div class="px-6 pb-6">
      <p class="text-gray-700">Are you sure you want to logout?</p>
    </div>

    <!-- Footer -->
    <div class="px-6 pb-6 flex gap-3">
      <button (click)="confirmLogout()" class="flex-1 px-4 py-2 bg-blue-700 text-white rounded-lg transition-colors">
        Yes
      </button>
      <button (click)="cancelLogout()"
        class="flex-1 px-4 py-2 border border-blue-500 text-blue-500 rounded-lg hover:bg-blue-50 transition-colors">
        No
      </button>
    </div>
  </div>
</div>

<!-- Date Picker Bottom Sheet Modal (Mobile Only) -->
<div *ngIf="showDatePicker && isMobile" class="fixed inset-0 z-50 flex items-end justify-center">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black bg-opacity-50" (click)="closeDatePicker()"></div>

  <!-- Modal Content - Bottom Sheet on Mobile -->
  <div class="relative w-full bg-white rounded-t-2xl shadow-lg max-h-[85vh] overflow-hidden">
    <!-- Calendar Header -->
    <div class="flex justify-between items-center p-4 border-b border-gray-200 bg-white sticky top-0">
      <div class="flex items-center gap-2">
        <button (click)="previousMonth()" class="p-1 hover:bg-gray-100 rounded">
          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        <div class="flex items-center gap-1">
          <span class="text-lg font-semibold text-gray-900">{{
            getCurrentMonthYear()
            }}</span>
          <button (click)="toggleMonthYearPicker()" class="p-1 hover:bg-gray-100 rounded">
            <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
        </div>
        <button (click)="nextMonth()" class="p-1 hover:bg-gray-100 rounded">
          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>
      <button (click)="closeDatePicker()" class="text-gray-400 hover:text-gray-600">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Month/Year Picker (when toggled) -->
    <div *ngIf="showMonthYearPicker" class="p-4 border-b border-gray-200">
      <div class="grid grid-cols-3 gap-2">
        <select [(ngModel)]="selectedYear" (change)="onYearChange()" class="p-2 border border-gray-300 rounded">
          <option *ngFor="let year of availableYears" [value]="year">
            {{ year }}
          </option>
        </select>
        <select [(ngModel)]="selectedMonth" (change)="onMonthChange()"
          class="p-2 border border-gray-300 rounded col-span-2">
          <option *ngFor="let month of monthNames; let i = index" [value]="i">
            {{ month }}
          </option>
        </select>
      </div>
    </div>

    <!-- Calendar Grid -->
    <div class="p-4">
      <!-- Days of Week Header -->
      <div class="grid grid-cols-7 gap-1 mb-2">
        <div *ngFor="let day of dayNames" class="text-center text-sm font-medium text-gray-500 py-2">
          {{ day }}
        </div>
      </div>

      <!-- Calendar Days -->
      <div class="grid grid-cols-7 gap-1">
        <div *ngFor="let day of calendarDays" class="text-center py-2 rounded cursor-pointer transition-colors"
          [ngClass]="{
            'text-gray-400': day.isOtherMonth,
            'text-gray-900 hover:bg-gray-100':
              !day.isOtherMonth && !day.isSelected && !day.isToday,
            'bg-blue-500 text-white font-semibold': day.isSelected,
            'bg-blue-100 text-blue-700 font-semibold':
              day.isToday && !day.isSelected,
            'opacity-50 cursor-not-allowed': day.isDisabled,
          }" (click)="selectDate(day)" [class.pointer-events-none]="day.isDisabled">
          {{ day.date }}
        </div>
      </div>
    </div>

    <!-- Footer with Back and Proceed buttons (Mobile Only) -->
    <div class="p-4 border-t border-gray-200 bg-white sticky bottom-0">
      <div class="flex gap-3">
        <button (click)="closeDatePicker()"
          class="flex-1 py-3 px-4 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50">
          Back
        </button>
        <button (click)="confirmDateSelection()" [disabled]="!selectedDateValue"
          class="flex-1 py-3 px-4 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Business Verification Modal -->
<div *ngIf="showBusinessVerificationModal"
  class="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-30 max-md:items-end max-md:justify-center md:justify-end">
  <div
    class="bg-white w-[420px] h-full shadow-lg flex flex-col relative animate-slide-in-right max-md:w-full max-md:h-auto max-md:max-h-[90vh] max-md:rounded-t-2xl md:w-[400px] lg:w-[420px]">
    <button type="button" class="absolute top-4 right-4 text-2xl z-10" (click)="closeBusinessVerificationModal()">
      ×
    </button>

    <div class="flex-1 overflow-y-auto p-8 max-md:p-6 md:p-6 lg:p-8">
      <h2 class="text-2xl font-bold text-blue-950 md:text-xl lg:text-2xl">
        {{ businessVerificationModalTitle }}
      </h2>
      <p *ngIf="businessVerificationStep === 'pan'" class="mt-2 mb-6 text-sm text-gray-600">
        Enter your PAN details. We will fetch linked GSTINs or guide you through shop license verification.
      </p>
      <p *ngIf="businessVerificationStep === 'gstin' && !isModalStepVerified('gstin') && gstItems.length"
        class="mt-2 mb-6 text-sm text-gray-600">
        Choose an active GSTIN linked to your PAN.
      </p>
      <p *ngIf="businessVerificationStep === 'udyam' && !isModalStepVerified('udyam')"
        class="mt-2 mb-6 text-sm text-gray-600">
        Enter your Udyam registration number.
      </p>
      <p *ngIf="businessVerificationStep === 'shop-license' && !isModalStepVerified('shop-license')"
        class="mt-2 mb-6 text-sm text-gray-600">
        Enter your shop license certificate details.
      </p>

      <div *ngIf="businessLoading && !businessVerificationStep" class="py-8 text-center text-sm text-gray-500">
        Fetching linked GSTINs...
      </div>

      <ng-container *ngIf="businessVerificationStep === 'pan'">
        <div class="flex flex-col gap-4">
          <div class="flex flex-col gap-1">
            <label class="text-sm font-bold text-zinc-700">Full Name (as on PAN)</label>
            <input type="text" [(ngModel)]="businessFullName" (blur)="businessFullNameTouched = true"
              placeholder="Enter name as on PAN card" class="p-2 w-full h-10 rounded-lg border text-base"
              [class.bg-zinc-100]="isPanVerified" [class.border-red-500]="getBusinessFullNameError()"
              [class.border-neutral-300]="!getBusinessFullNameError()" [readonly]="isPanVerified" />
            <div *ngIf="getBusinessFullNameError()" class="text-red-500 text-xs mt-1">
              {{ getBusinessFullNameError() }}
            </div>
          </div>
          <div class="flex flex-col gap-1">
            <label class="text-sm font-bold text-zinc-700">PAN Number</label>
            <input type="text" [(ngModel)]="businessPanNumber" (input)="onBusinessPanInput($event)"
              (blur)="businessPanTouched = true" placeholder="ABCDE1234F" maxlength="10"
              class="p-2 w-full h-10 rounded-lg border text-base uppercase" [class.bg-zinc-100]="isPanVerified"
              [class.border-red-500]="getBusinessPanError()" [class.border-neutral-300]="!getBusinessPanError()"
              [readonly]="isPanVerified" />
            <div *ngIf="getBusinessPanError()" class="text-red-500 text-xs mt-1">
              {{ getBusinessPanError() }}
            </div>
          </div>
        </div>
        <div *ngIf="businessVerificationError" class="text-red-500 text-sm mt-4">
          {{ businessVerificationError }}
        </div>
        <button type="button" (click)="onBusinessPanSubmit()"
          class="mt-6 w-full p-2.5 text-white rounded-lg bg-blue-950 font-bold"
          [class.opacity-60]="!isBusinessPanValid() || businessLoading"
          [disabled]="!isBusinessPanValid() || businessLoading">
          <ng-container *ngIf="!businessLoading">Continue</ng-container>
          <ng-container *ngIf="businessLoading">Verifying...</ng-container>
        </button>
      </ng-container>

      <ng-container *ngIf="businessVerificationStep === 'gstin'">
        <ng-container *ngIf="isModalStepVerified('gstin'); else gstinPending">
          <ng-container *ngTemplateOutlet="verifiedNumber; context: { step: 'gstin' }"></ng-container>
        </ng-container>
        <ng-template #gstinPending>
          <div *ngIf="!gstItems.length" class="mt-2 mb-4 text-sm text-gray-600">
            No GSTIN found for this PAN
          </div>
          <div *ngIf="gstItems.length" class="flex flex-col gap-2 max-h-[45vh] overflow-y-auto mb-4">
            <div *ngFor="let g of gstItems"
              class="relative flex justify-between items-center p-3 rounded-lg border min-h-[56px] transition-colors"
              [class.border-blue-500]="isGstinSelected(g)" [class.bg-blue-50]="isGstinSelected(g)"
              [class.border-neutral-300]="!isGstinSelected(g)" [class.opacity-50]="!isGstinActive(g)"
              [class.cursor-pointer]="isGstinActive(g)" [style.pointer-events]="isGstinActive(g) ? 'auto' : 'none'"
              (click)="onGstinSelect(g)">
              <div class="flex flex-col pr-16 min-w-0">
                <span class="font-bold text-sm break-all">{{ g.document_number || g.gstin }}</span>
                <span class="text-xs text-neutral-500">{{ g.state }}</span>
              </div>
              <span *ngIf="!isGstinActive(g)"
                class="absolute top-2 right-2 text-[10px] font-medium text-red-500 uppercase">
                {{ g.status || g.gstin_status }}
              </span>
            </div>
          </div>
          <div *ngIf="gstinErrorMessage" class="text-red-500 text-sm mb-3">
            {{ gstinErrorMessage }}
          </div>
          <button *ngIf="gstItems.length" type="button" (click)="onGstinSubmit()"
            class="w-full p-2.5 text-white rounded-lg bg-blue-950 font-bold"
            [class.opacity-60]="!selectedGstin || gstinLoading" [disabled]="!selectedGstin || gstinLoading">
            <ng-container *ngIf="!gstinLoading">Continue</ng-container>
            <ng-container *ngIf="gstinLoading">Verifying...</ng-container>
          </button>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="businessVerificationStep === 'udyam'">
        <button type="button" (click)="goBackToGstinStep()" class="mb-4 text-sm font-semibold text-blue-950 underline">
          &larr; Back
        </button>
        <ng-container *ngIf="isModalStepVerified('udyam'); else udyamPending">
          <ng-container *ngTemplateOutlet="verifiedNumber; context: { step: 'udyam' }"></ng-container>
        </ng-container>
        <ng-template #udyamPending>
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-1">
              <label class="text-sm font-bold text-zinc-700">Udyam Number</label>
              <select *ngIf="udyamItems.length; else udyamManualInput" [(ngModel)]="udyamNumber"
                (ngModelChange)="onUdyamSelect()" (blur)="udyamNumberTouched = true"
                class="p-2 w-full h-10 rounded-lg border text-base uppercase bg-white"
                [class.border-red-500]="getUdyamNumberError()" [class.border-neutral-300]="!getUdyamNumberError()">
                <option value="" disabled>Select Udyam number</option>
                <option *ngFor="let item of udyamItems" [ngValue]="getUdyamNumber(item)">
                  {{ getUdyamNumber(item) }}
                </option>
              </select>
              <ng-template #udyamManualInput>
                <input type="text" [(ngModel)]="udyamNumber" (input)="onUdyamInput($event)"
                  (blur)="udyamNumberTouched = true" placeholder="UDYAM-XX-00-0000000" maxlength="19"
                  class="p-2 w-full h-10 rounded-lg border text-base uppercase"
                  [class.border-red-500]="getUdyamNumberError()" [class.border-neutral-300]="!getUdyamNumberError()" />
              </ng-template>
              <div *ngIf="getUdyamNumberError()" class="text-red-500 text-xs mt-1">
                {{ getUdyamNumberError() }}
              </div>
            </div>
            <div *ngIf="udyamLoading && !udyamItems.length" class="text-xs text-neutral-500">
              Fetching Udyam numbers...
            </div>
            <div *ngIf="selectedUdyamItem?.state || selectedUdyamItem?.address"
              class="flex flex-col gap-1 p-3 text-sm text-zinc-700 rounded-lg border border-neutral-300 bg-zinc-100">
              <span *ngIf="selectedUdyamItem?.state">State: {{ selectedUdyamItem?.state }}</span>
              <span *ngIf="selectedUdyamItem?.address">
                Address: {{ selectedUdyamItem?.address }}<ng-container *ngIf="selectedUdyamItem?.pincode"> - {{
                  selectedUdyamItem?.pincode }}</ng-container>
              </span>
            </div>
          </div>
          <div *ngIf="udyamErrorMessage" class="text-red-500 text-sm mt-4">
            {{ udyamErrorMessage }}
          </div>
          <button type="button" (click)="onUdyamSubmit()"
            class="mt-6 w-full p-2.5 text-white rounded-lg bg-blue-950 font-bold"
            [class.opacity-60]="!isUdyamValid() || udyamLoading" [disabled]="!isUdyamValid() || udyamLoading">
            <ng-container *ngIf="!udyamLoading">Continue</ng-container>
            <ng-container *ngIf="udyamLoading">Verifying...</ng-container>
          </button>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="businessVerificationStep === 'shop-license'">
        <button type="button" (click)="goBackToGstinStep()" class="mb-4 text-sm font-semibold text-blue-950 underline">
          &larr; Back
        </button>
        <ng-container *ngIf="isModalStepVerified('shop-license'); else shopLicensePending">
          <ng-container *ngTemplateOutlet="verifiedNumber; context: { step: 'shop-license' }"></ng-container>
        </ng-container>
        <ng-template #shopLicensePending>
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-1">
              <label class="text-sm font-bold text-zinc-700">Certificate Number</label>
              <input type="text" [(ngModel)]="shopLicenseNumber" (blur)="shopLicenseNumberTouched = true"
                placeholder="Enter certificate number" class="p-2 w-full h-10 rounded-lg border text-base"
                [class.border-red-500]="getShopLicenseNumberError()"
                [class.border-neutral-300]="!getShopLicenseNumberError()" />
              <div *ngIf="getShopLicenseNumberError()" class="text-red-500 text-xs mt-1">
                {{ getShopLicenseNumberError() }}
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-sm font-bold text-zinc-700">State</label>
              <select [(ngModel)]="shopLicenseState" (blur)="shopLicenseStateTouched = true"
                class="p-2 w-full h-10 rounded-lg border bg-white text-base"
                [class.border-red-500]="getShopLicenseStateError()"
                [class.border-neutral-300]="!getShopLicenseStateError()">
                <option value="" disabled>Select state</option>
                <option *ngFor="let state of shopLicenseStates" [value]="state">
                  {{ formatShopLicenseStateLabel(state) }}
                </option>
              </select>
              <div *ngIf="getShopLicenseStateError()" class="text-red-500 text-xs mt-1">
                {{ getShopLicenseStateError() }}
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-sm font-bold text-zinc-700">District</label>
              <input type="text" [(ngModel)]="shopLicenseDistrict" (blur)="shopLicenseDistrictTouched = true"
                placeholder="Enter district" class="p-2 w-full h-10 rounded-lg border text-base"
                [class.border-red-500]="getShopLicenseDistrictError()"
                [class.border-neutral-300]="!getShopLicenseDistrictError()" />
              <div *ngIf="getShopLicenseDistrictError()" class="text-red-500 text-xs mt-1">
                {{ getShopLicenseDistrictError() }}
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-sm font-bold text-zinc-700">Commencement Date</label>
              <input type="date" [(ngModel)]="shopLicenseCommencementDate"
                (blur)="shopLicenseCommencementDateTouched = true" class="p-2 w-full h-10 rounded-lg border text-base"
                [class.border-red-500]="getShopLicenseCommencementDateError()"
                [class.border-neutral-300]="!getShopLicenseCommencementDateError()" />
              <div *ngIf="getShopLicenseCommencementDateError()" class="text-red-500 text-xs mt-1">
                {{ getShopLicenseCommencementDateError() }}
              </div>
            </div>
          </div>
          <div *ngIf="shopLicenseErrorMessage" class="text-red-500 text-sm mt-4">
            {{ shopLicenseErrorMessage }}
          </div>
          <button type="button" (click)="onShopLicenseSubmit()"
            class="mt-6 w-full p-2.5 text-white rounded-lg bg-blue-950 font-bold"
            [class.opacity-60]="!isShopLicenseValid() || shopLicenseLoading"
            [disabled]="!isShopLicenseValid() || shopLicenseLoading">
            <ng-container *ngIf="!shopLicenseLoading">Continue</ng-container>
            <ng-container *ngIf="shopLicenseLoading">Verifying...</ng-container>
          </button>
        </ng-template>
      </ng-container>

      <div *ngIf="businessVerificationStep && businessVerificationStep !== 'pan' && switchableBusinessSteps.length"
        class="mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-gray-600">
        <span>Verify with:</span>
        <button *ngFor="let type of switchableBusinessSteps" type="button" (click)="switchBusinessStep(type)"
          class="font-semibold text-blue-950 underline">
          {{ getBusinessStepLabel(type) }}
        </button>
      </div>

      <ng-template #verifiedNumber let-step="step">
        <div class="flex flex-wrap items-center gap-2 p-3 rounded-lg border border-neutral-300 bg-zinc-100">
          <span
            class="inline-flex items-center px-2 py-0.5 text-xs font-semibold text-green-700 bg-green-50 rounded-full border border-green-200">
            Verified
          </span>
          <span class="text-sm font-medium text-zinc-700 break-all">{{
            getModalStepSummary(step)
            }}</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>